// import React from "react";
// import { Navigate, Outlet } from "react-router-dom";

// const ProtectedRoute = ({ userInfo, userModules = [], routeModule }) => {

//   if (userInfo.userrole && userInfo.userrole === "SYS_ADMIN") {
//     const isSuperAdmin = userInfo.userrole === "SYS_ADMIN";
//     if (isSuperAdmin) {
//       return <Outlet />;
//     }
//   }

//   if (userInfo.userrole && userModules.length) {
//     const hasAccess = userModules.some((module) => module.url.includes(routeModule));
//     const subscriptionEndDate = new Date(userInfo.subscription.end_date);
//     const currentDate = new Date();
//     //     
//     if (subscriptionEndDate <= currentDate) {
//       //     
//       return <Navigate to="/402" />;
//     }
//     if (!hasAccess) {
//       return <Navigate to="/403" />;
//     }
//   }


//   return <Outlet />;
// };

// export default ProtectedRoute;


import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ userInfo, userModules = [], routeModule }) => {
  // Super admin bypass
  if (userInfo.userrole && userInfo.userrole === "SYS_ADMIN") {
    return <Outlet />;
  }

  // For other users
  if (userInfo.userrole && userModules.length) {
    // Check subscription
    let subscriptionEndDate = null;
    if (userInfo.subscription && userInfo.subscription.end_date) {
      subscriptionEndDate = new Date(userInfo.subscription.end_date);
    }

    const currentDate = new Date();
    if (subscriptionEndDate && subscriptionEndDate <= currentDate) {
      return <Navigate to="/402" />; // Subscription expired
    }

    // ✅ Define hasAccess before using it
    const hasAccess = userModules.some((module) =>
      module.url.includes(routeModule)
    );

    if (!hasAccess) {
      return <Navigate to="/403" />; // Forbidden
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
